import React from "react";
import PublicLayout from "@/components/PublicLayout";
import { useLang } from "@/lib/i18n";
import useSEO from "@/lib/useSEO";

const HISTORY_IMG = "/api/files/melograno/properties/2cbf32a0-ee6e-4365-89bf-51811609e3b4.webp";

export default function Story() {
  const { t, lang } = useLang();
  useSEO({
    lang, path: "/storia",
    title: lang === "en" ? "Our Story — Il Melograno since 1978" : "La nostra storia — Il Melograno dal 1978",
    description: lang === "en"
      ? "Il Melograno Cultural Association, founded in 1978 in Castellanza to promote encounters across cultures. The apARTments project welcomes guests in a warm, refined space."
      : "L'Associazione Culturale Il Melograno nasce nel 1978 a Castellanza per promuovere l'incontro tra culture. Il progetto apARTments accoglie i nostri ospiti in un ambiente caldo e ricercato.",
  });
  return (
    <PublicLayout>
      <section className="mel-container pt-16 pb-24">
        <div className="grid lg:grid-cols-12 gap-12 items-end mb-16">
          <div className="lg:col-span-6">
            <div className="eyebrow mb-4">{t.story.eyebrow}</div>
            <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl leading-tight tracking-tight break-words">
              {t.story.titleA} <em className="text-[var(--mel-primary)]">{t.story.titleB}</em>{t.story.titleC}
            </h1>
          </div>
          <div className="lg:col-span-6 text-[var(--mel-muted)] leading-relaxed text-lg">
            <p>{t.story.intro}</p>
          </div>
        </div>

        <img src={HISTORY_IMG} alt="Facciata storica dell'Associazione Culturale Il Melograno a Castellanza, attiva dal 1978" className="w-full h-[520px] object-cover rounded-md mb-16" data-testid="story-hero" />

        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="eyebrow mb-3">{t.story.projectEyebrow}</div>
            <h2 className="font-serif text-3xl tracking-tight">{t.story.projectTitle}</h2>
          </div>
          <div className="lg:col-span-7 lg:col-start-6 text-[var(--mel-muted)] leading-relaxed">
            <p className="mb-6">{t.story.p2}</p>
            <p className="mb-6">{t.story.p3}</p>
            <p>{t.story.p1}</p>
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
